import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";
import MultiStepModal from "./MultiStepModal";
import {
  addQuestion,
  deleteQuestion,
  getQuestions,
  toggleQuestionActive,
  updateQuestion,
} from "../../../slices/5-question/thunk";

const QuestionsTable = () => {
  const dispatch = useDispatch();

  const { questions, loading, error, totalPages } = useSelector(
    (state) => state.Question,
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [opentoggleModalopen, setOpenToggleModalopen] = useState(false);

  const [editingQuestion, setEditingQuestion] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRanked, setSelectedRanked] = useState(null);
  const [isActiveStatus, setIsActiveStatus] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);

    if (modalOpen) {
      setEditingQuestion(null);
      setIsEdit(false);
    }
  };

  // GET QUESTIONS
  useEffect(() => {
    dispatch(getQuestions({ page, limit, search: searchTerm }));
  }, [dispatch, page, searchTerm]);

  // SEARCH debounce
  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchTerm.length >= 3 || searchTerm.length === 0) {
        dispatch(getQuestions({ page, limit, search: searchTerm }));
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handleAddQuestion = (data) => {
    const action = isEdit
      ? updateQuestion({
          id: editingQuestion?._id,
          data,
        })
      : addQuestion(data);

    dispatch(action)
      .unwrap()
      .then(() => {
        setModalOpen(false);
        setEditingQuestion(null);
        setIsEdit(false);

        dispatch(getQuestions({ page, limit }));
      });
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteQuestion(selectedId))
      .unwrap()
      .then(() => {
        setDeleteModal(false);
        dispatch(getQuestions({ page, limit }));
      })
      .catch((err) => toast.error(err?.message));
  };

  const openEditModal = (question) => {
    setEditingQuestion(question);
    setIsEdit(true);
    setModalOpen(true);
  };

  const toggleModalopen = (item) => {
    setSelectedRanked(item);
    setIsActiveStatus(item.isActive);
    setOpenToggleModalopen(true);
  };

  const confirmToggleActive = () => {
    if (selectedRanked) {
      dispatch(toggleQuestionActive(selectedRanked?._id));
      setOpenToggleModalopen(false);
      setSelectedRanked(null);
    }
  };

  // console.log(questions);
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="إدارة الأسئلة" />

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                {/* TOP BAR */}
                <Row className="mb-3">
                  <Col>
                    <input
                      className="form-control"
                      placeholder="بحث..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </Col>

                  <Col className="text-end">
                    <Button color="success" onClick={toggleModal}>
                      إضافة سؤال
                    </Button>
                  </Col>
                </Row>

                {/* TABLE */}
                <div className="table-responsive">
                  <table className="table text-center">
                    <thead>
                      <tr>
                        <th>رقم</th>
                        <th>السؤال</th>
                        {/* <th>التصنيف</th> */}
                        <th>نوع السؤال</th>
                        <th>نوع المسابقة</th>
                        <th>الإجابة</th>
                        <th>الحالة</th>
                        <th>الإجراءات</th>
                      </tr>
                    </thead>

                    <tbody>
                      {questions?.length > 0 ? (
                        questions.map((q, i) => (
                          <tr key={q._id}>
                            <td>{i + 1}</td>
                            <td
                              className="text-nowrap"
                              style={{
                                maxWidth: "250px",
                                overflow: "hidden",
                              }}
                            >
                              {q.question || "-"}
                            </td>
                            {/* <td>
                              <span className="badge rounded-pill bg-primary px-3 py-2">
                                {q.category?.name || "-"}
                              </span>
                            </td> */}
                            <td>
                              <span
                                className="badge rounded-pill px-3 py-2"
                                style={{
                                  backgroundColor: "#E7EFE9",
                                  color: "#41584D",
                                  fontWeight: "500",
                                }}
                              >
                                {q.type}
                              </span>
                            </td>
                            <td className="d-flex gap-2 justify-content-center">
                              <span
                                className="badge rounded-pill px-3 py-2"
                                style={{
                                  backgroundColor: "#E7EFE9",
                                  color: "#41584D",
                                  fontWeight: "500",
                                }}
                              >
                                {q.isRanked && "Ranked"}
                              </span>
                              <span
                                className="badge rounded-pill px-3 py-2"
                                style={{
                                  backgroundColor: "#E7EFE9",
                                  color: "#41584D",
                                  fontWeight: "500",
                                }}
                              >
                                {q.isUnRanked && "UnRanked"}
                              </span>
                            </td>
                            {/* <td>{q.type}</td> */}
                            <td>
                              {q.options?.find((o) => o.isCorrect)?.text ||
                                q.answer}
                            </td>
                            <td>
                              <span
                                className={`badge rounded-pill ${
                                  q.isActive ? "bg-success" : "bg-danger"
                                }`}
                              >
                                {q.isActive ? "نشطة" : "غير نشط"}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex gap-3 justify-content-center">
                                <div className="edit">
                                  <button
                                    className="btn btn-sm edit-item-btn"
                                    style={{
                                      padding: "0px",
                                      background: "transparent",
                                      border: "none",
                                    }}
                                    onClick={() => openEditModal(q)}
                                  >
                                    <i
                                      className="ri-edit-line"
                                      style={{
                                        color: "gray",
                                        fontSize: "20px",
                                      }}
                                    ></i>
                                  </button>
                                </div>
                                <button
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                  }}
                                  onClick={() => handleDelete(q._id)}
                                >
                                  <i
                                    className="ri-delete-bin-line"
                                    style={{
                                      fontSize: "20px",
                                      color: "#e74c3c",
                                    }}
                                  ></i>
                                </button>
                                {/* Toggle */}
                                <button
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                  }}
                                  onClick={() => toggleModalopen(q)}
                                >
                                  <i
                                    className={
                                      q.isActive
                                        ? "ri-toggle-fill"
                                        : "ri-toggle-line"
                                    }
                                    style={{
                                      color: q.isActive ? "green" : "gray",
                                      fontSize: "22px",
                                    }}
                                  ></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8">لا يوجد بيانات</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* PAGINATION */}
                <Pagination
                  currentPage={page}
                  totalPages={totalPages}
                  onPageChange={setPage}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الحذف
        </ModalHeader>

        <ModalBody>
          <div className="mt-2 text-center">
            <i className="ri-delete-bin-line display-3 text-danger"></i>

            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>

              <p className="text-muted mx-4 mb-0">
                هل تريد حذف هذا السؤال؟ لا يمكن التراجع عن هذا الإجراء
              </p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>

            <Button color="danger" onClick={confirmDelete}>
              نعم، حذف
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={opentoggleModalopen}
        toggle={() => setOpenToggleModalopen(false)}
        centered
      >
        <ModalHeader toggle={() => setOpenToggleModalopen(false)}>
          تأكيد الحالة
        </ModalHeader>

        <ModalBody>
          <div className="mt-2 text-center">
            <i
              className={`ri-information-line display-3 ${
                isActiveStatus ? "text-danger" : "text-success"
              }`}
            ></i>

            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>

              <p className="text-muted mx-4 mb-0">
                هل تريد {isActiveStatus ? "إيقاف" : "تفعيل"} هذا السؤال؟
              </p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setOpenToggleModalopen(false)}>
              إلغاء
            </Button>

            <Button
              color={isActiveStatus ? "danger" : "success"}
              onClick={confirmToggleActive}
            >
              نعم، {isActiveStatus ? "إيقاف" : "تفعيل"}
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      {/* ADD MODAL */}
      <MultiStepModal
        isOpen={modalOpen}
        toggle={toggleModal}
        onSubmit={handleAddQuestion}
        initialData={editingQuestion}
        isEdit={isEdit}
      />
    </div>
  );
};

export default QuestionsTable;
